import { render } from "./PaymentsTable.vue?vue&type=template&id=6820b002&scoped=true"
import script from "./PaymentsTable.vue?vue&type=script&lang=js"
export * from "./PaymentsTable.vue?vue&type=script&lang=js"

import "./PaymentsTable.vue?vue&type=style&index=0&id=6820b002&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6820b002"]])

export default __exports__